import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";

const API_URL = environment.apiUrl;

// ============================================================
// Request/Response Types (inline — matches backend DTOs)
// ============================================================

interface ConvertBookkeepingDocumentTemplateRequest {
  token: string;
  companyKey: string;
  docType: number;
  projectID: number;
  contactID: number;
  bKDocTypeID: number;
}

interface ConvertBookkeepingDocumentTemplateResponse {
  success: boolean;
  message: string;
  baseTemplateHtml: string;
  tagsValues?: { tagKey: string; tagValue: string }[];
}

// ============================================================
// ConvertBookkeepingDocumentTemplate — מקבל HTML + tags מוחלפים
// ============================================================

export const convertBookkeepingDocumentTemplate = createAsyncThunk<
  ConvertBookkeepingDocumentTemplateResponse,
  ConvertBookkeepingDocumentTemplateRequest,
  { rejectValue: string }
>(
  "bookkeepingEditing/convertBookkeepingDocumentTemplate",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}BookkeepingDocument/ConvertBookkeepingDocumentTemplate`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(request),
        },
      );

      if (!response.ok) {
        return rejectWithValue(`שגיאת שרת: ${response.status}`);
      }

      const data: ConvertBookkeepingDocumentTemplateResponse =
        await response.json();

      if (!data.success) {
        return rejectWithValue(data.message || "שגיאה בהמרת תבנית");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "שגיאה בחיבור לשרת");
    }
  },
);
